import { useContext, Context } from 'react';
import ModalContext from 'contexts/ModalContext';

function useModal(): any {
  return useContext(ModalContext);
}

export default useModal;
